import { EventType } from "@/global/store/data/types";
import { convertDate, convertTime } from "@/global/utils/dateTimeConvert";
import { Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import Image from "next/image";

export function CommonEventCard(props: { event: EventType }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid  ${theme.palette.divider}`,
        borderRadius: "8px",
      }}
    >
      <Box p={1} py={1}>
        <Stack
          direction={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          spacing={2}
        >
          <Box>
            {props?.event?.logoUrl ? (
              <Image
                src={props?.event?.logoUrl}
                alt={"StadiumBackground team logo"}
                width={48}
                height={48}
                style={{
                  objectFit: "contain",
                }}
              />
            ) : null}
          </Box>

          <Box textAlign={"left"}>
            <Typography fontSize={"1rem"} fontWeight={700}>
              {props?.event?.title}
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Divider />
      <Box
        display={"flex"}
        alignItems={"center"}
        padding={"1rem"}
        gap={"0.5rem"}
      >
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={"0.9rem"}
          fontWeight={"500"}
        >
          {convertDate(props?.event?.date)}
        </Typography>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={"0.9rem"}
          fontWeight={"500"}
        >
          {convertTime(props?.event?.time)}
        </Typography>
      </Box>
    </Box>
  );
}
